import { EyeInvisibleOutlined, EyeOutlined, LoadingOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { Spin } from 'antd';
import { SEOResponse, useSEOUpdate } from '../../../../hooks/api/SEO';
import { useMessageError } from '../../../../hooks/common';

import styles from './index.module.scss';

export interface ButtonEyeProps {
  seo: SEOResponse;
  onChange: () => void;
  loading?: boolean;
}

export default function ButtonEye({ seo, onChange, loading }: ButtonEyeProps) {
  const seoUpdate = useSEOUpdate(seo.id);

  useEffect(() => {
    if (!seoUpdate.error && !seoUpdate.loading && seoUpdate.data) {
      onChange();
    }
  }, [seoUpdate.data]);

  useMessageError([seoUpdate]);

  useEffect(() => {
    if (!loading) {
      seoUpdate.clearResponse();
    }
  }, [loading]);

  if (seoUpdate.loading || (loading && seoUpdate.data)) {
    return (
      <Spin
        indicator={<LoadingOutlined spin />}
        style={{ padding: 6 }}
      />
    );
  }

  return !seo.isActive ? (
    <EyeInvisibleOutlined
      title="click and show"
      className={styles.icon}
      onClick={(e) => {
        e.preventDefault();
        seoUpdate.fetch({
          isActive: true,
        });
      }}
      size={20}
    />
  ) : (
    <EyeOutlined
      title="click and hide"
      className={styles.icon}
      onClick={(e) => {
        e.preventDefault();
        seoUpdate.fetch({
          isActive: false,
        });
      }}
      size={20}
    />
  );
}
